import { categories } from "./Categories"
import { applications } from "./Applications"
const apiCalls={
    categories,
    applications
}
export {apiCalls}